import script from "./RequiredItemsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RequiredItemsDialog.vue?vue&type=script&setup=true&lang=js"

import "./RequiredItemsDialog.vue?vue&type=style&index=0&id=b34122f6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b34122f6"]])

export default __exports__